import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f2b53ae")

_pushScopeId("data-v-5f2b53ae")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "section"
}
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = { class: "image is-128x128 img-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { "data-testid": "profile-username" }
const _hoisted_8 = { class: "align-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" CHAT ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "columns is-desktop" }
const _hoisted_13 = { class: "column is-three-fifths-desktop" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "diplay-inline margin-b-24" }, [
  /*#__PURE__*/_createVNode("h4", { class: "title is-4 diplay-inline" }, "Description")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "box shadow" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createVNode("h4", { class: "title is-4" }, "Skill", -1)
const _hoisted_20 = { class: "box shadow" }
const _hoisted_21 = {
  key: 0,
  class: "box-white-border is-8-min-height-em "
}
const _hoisted_22 = {
  key: 1,
  class: "box-white-border is-8-min-height-em display-center"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "column is-1" }, null, -1)
const _hoisted_24 = { class: "column" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h4", { class: "title is-4" }, "Level", -1)
const _hoisted_26 = { class: "box shadow" }
const _hoisted_27 = { class: "box-white-border diplay-inline" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h4", { class: "title is-4" }, "CTF", -1)
const _hoisted_29 = { class: "box shadow" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "align-center"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("h4", { class: "title is-4" }, "Language", -1)
const _hoisted_33 = { class: "box shadow" }
const _hoisted_34 = {
  key: 0,
  class: "margin-b-24"
}
const _hoisted_35 = { class: "image is-16x16 diplay-inline " }
const _hoisted_36 = {
  key: 1,
  class: "display-center"
}
const _hoisted_37 = { class: "modal-card" }
const _hoisted_38 = { class: "modal-card-head" }
const _hoisted_39 = { class: "modal-card-title" }
const _hoisted_40 = { class: "modal-card-body" }
const _hoisted_41 = { class: "field" }
const _hoisted_42 = { class: "control" }
const _hoisted_43 = { class: "modal-card-foot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_loader = _resolveComponent("loader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_loader)
        ]))
      : (_ctx.user && _ctx.user.findOneUser)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("figure", _hoisted_5, [
                _createVNode("img", {
                  class: "is-rounded",
                  src: _ctx.getLink(_ctx.user.findOneUser.hashedUsername)
                }, null, 8, ["src"])
              ]),
              _hoisted_6,
              _createVNode("b", _hoisted_7, _toDisplayString(_ctx.user.findOneUser.username), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("button", {
                class: "button no-border border-r-15 is-small margin-t-20",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSendMessageOpen = true))
              }, [
                _hoisted_9,
                _hoisted_10
              ])
            ]),
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  (_ctx.user.findOneUser.description == '')
                    ? (_openBlock(), _createBlock("p", _hoisted_17, " No description yet "))
                    : (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(_ctx.user.findOneUser.description), 1))
                ]),
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  (_ctx.user.findOneUser.skills.length > 0 && !_ctx.tagLoading)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.findOneUser.skills, (tag) => {
                          return (_openBlock(), _createBlock("span", {
                            class: "custom-tag-profile",
                            key: tag,
                            style: { backgroundColor: _ctx.findTagColor(tag) }
                          }, _toDisplayString(tag.replace(" ", " ")), 5))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_22, " Not completed "))
                ])
              ]),
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.user.findOneUser.level), 1)
                ]),
                _hoisted_28,
                _createVNode("div", _hoisted_29, [
                  (_ctx.user.findOneUser.ctfs.length > 0 && !_ctx.ctfLoading)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.findOneUser.ctfs, (ctfName) => {
                          return (_openBlock(), _createBlock("span", {
                            class: "box-white-border margin-ctf-name diplay-inline",
                            key: ctfName
                          }, _toDisplayString(_ctx.findCtfById(ctfName)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_31, " Not completed "))
                ]),
                _createVNode("div", null, [
                  _hoisted_32,
                  _createVNode("div", _hoisted_33, [
                    (_ctx.user.findOneUser.language.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.findOneUser.language, (l) => {
                            return (_openBlock(), _createBlock("div", {
                              key: l,
                              class: "box-white-border language-box"
                            }, [
                              _createVNode("figure", _hoisted_35, [
                                _createVNode("img", {
                                  class: "is-rounded ",
                                  src: `/img/flag-country/${l}.png`
                                }, null, 8, ["src"])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_36, " Not completed "))
                  ])
                ])
              ])
            ]),
            _createVNode("div", {
              class: `modal ${_ctx.isSendMessageOpen ? 'is-active' : ''}`
            }, [
              _createVNode("div", {
                class: "modal-background",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSendMessageOpen = false))
              }),
              _createVNode("div", {
                class: `modal ${_ctx.isSendMessageOpen ? 'is-active' : ''}`
              }, [
                _createVNode("div", {
                  class: "modal-background",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSendMessageOpen = false))
                }),
                _createVNode("div", _hoisted_37, [
                  _createVNode("header", _hoisted_38, [
                    _createVNode("p", _hoisted_39, "Message to " + _toDisplayString(_ctx.username), 1),
                    _createVNode("button", {
                      class: "delete",
                      "aria-label": "close",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSendMessageOpen = false))
                    })
                  ]),
                  _createVNode("section", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _withDirectives(_createVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.textToSend = $event)),
                          class: "textarea",
                          placeholder: "Hey! I'm looking for a team mate for..."
                        }, null, 512), [
                          [_vModelText, _ctx.textToSend]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("footer", _hoisted_43, [
                    _createVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                      class: "button is-success"
                    }, " Send "),
                    _createVNode("button", {
                      class: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isSendMessageOpen = false))
                    }, " Cancel ")
                  ])
                ])
              ], 2)
            ], 2)
          ]))
        : _createCommentVNode("", true)
  ]))
})